import { createContext } from 'react'
import type { ProjectStakeholder, StakeholderTemplate } from '@bandos/shared'

export interface StakeholderActionResult {
  success: boolean
  error?: string
  errorCode?: string
}

export interface StakeholderContextType {
  // State
  projectStakeholders: ProjectStakeholder[]
  loading: boolean
  error: string | null

  // Actions
  reloadStakeholders: (mindmapId: string) => Promise<void>
  addStakeholder: (mindmapId: string, templateId: string) => Promise<StakeholderActionResult>
  removeStakeholder: (mindmapId: string, stakeholderId: string) => Promise<StakeholderActionResult>
  createTemplate: (
    templateData: Omit<
      StakeholderTemplate,
      'created_at' | 'updated_at' | 'is_public' | 'created_by_user_id'
    > & { id: string }
  ) => Promise<StakeholderActionResult & { template?: StakeholderTemplate }>
  updateTemplate: (
    templateId: string,
    templateData: Partial<
      Omit<
        StakeholderTemplate,
        'id' | 'created_at' | 'updated_at' | 'is_public' | 'created_by_user_id'
      >
    >
  ) => Promise<StakeholderActionResult & { template?: StakeholderTemplate }>
  deleteTemplate: (templateId: string) => Promise<StakeholderActionResult>
}

export const StakeholderContext = createContext<StakeholderContextType | undefined>(undefined)
